export default __webpack_public_path__ + "static/media/ic-clock-white.9e6139c7.svg";